// extracted by mini-css-extract-plugin
module.exports = {"beta":"InboxMenuItem_beta__3lJOn"};